import React, { PureComponent, RefObject, createRef } from "react";
import { Subscription, Subject } from "rxjs";
import insertTextAtCursor from "insert-text-at-cursor";

type SubscriptionFactory = (subject: Subject<string>) => Subscription[];

type RxProps = {
	onChange: (input: string) => void;
	inputProps: {};
	subscriptionFactory: SubscriptionFactory;
	value: string;
};

export default class RxTextarea extends PureComponent<RxProps> {
	subscriptions = [] as Subscription[];
	subject$: Subject<string>;
	textarea = null as RefObject<HTMLTextAreaElement>;

	constructor(props: RxProps) {
		super(props);

		this.subject$ = new Subject();
		this.textarea = createRef<HTMLTextAreaElement>();
	}

	clear = () => {
		this.props.onChange("");
	};

	focus = () => {
		this.textarea.current.focus();
	};

	componentDidMount() {
		this.subscriptions = this.props.subscriptionFactory(this.subject$);
	}

	componentWillUnmount() {
		if (this.subscriptions) {
			for (let subscription of this.subscriptions) {
				subscription.unsubscribe();
			}
		}
	}

	insertAtCursor = (text: string) => {
		insertTextAtCursor(this.textarea.current, text);
	};

	handleChange = ({ target }: { target: HTMLTextAreaElement }) => {
		const value = target.value;
		if (!value) {
			this.props.onChange("");
		}

		this.props.onChange(value);
		this.subject$.next(value);
	};

	render() {
		return (
			<textarea
				{...this.props.inputProps}
				onChange={this.handleChange}
				value={this.props.value}
				ref={this.textarea}
			/>
		);
	}
}
